module.exports = __webpack_public_path__ + "static/media/or.17198303.svg";